import { createContext } from 'react';

/** 宿主已挂载全站预览时，仅标记能力，不把播放器依赖带入上下文入口。 */
export const MyIpMediaPreviewHostContext = createContext(false);
